/**
 * Normalize scroll calculation diffs between a HTMLElement and the Window.
 */
import { isWindow, isHtmlElement, getWindow } from "../utils"

const getWindowScroll = (node: Window) => ({
  scrollLeft: node.pageXOffset,
  scrollTop: node.pageYOffset
})

const getHTMLElementScroll = ({ scrollLeft, scrollTop }: HTMLElement) => ({
  scrollLeft,
  scrollTop
})

const getScroll = (node: Node) =>
  isWindow(node) || !isHtmlElement(node)
    ? getWindowScroll(getWindow(node))
    : getHTMLElementScroll(node)

export default getScroll
